import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    // Make sure the first tab is selected by default
    this.showTab("upcoming")
  }

  toggle(event) {
    // Get the tab to show from the data-tab attribute
    const tab = event.currentTarget.dataset.tab
    this.showTab(tab)
  }

  showTab(tabName) {
    // Update tab styles
    this.tabTargets.forEach(tab => {
      if (tab.dataset.tab === tabName) {
        // Active tab
        tab.classList.add("text-zinc-100", "border-b-2", "border-[#ff5101]")
        tab.classList.remove("text-zinc-400", "hover:text-zinc-300")
      } else {
        // Inactive tab
        tab.classList.remove("text-zinc-100", "border-b-2", "border-[#ff5101]")
        tab.classList.add("text-zinc-400", "hover:text-zinc-300") 
      }
    })

    // Show/hide panels
    this.panelTargets.forEach(panel => {
      if (panel.dataset.tab === tabName) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }
} 